import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { UserService } from '../../../../shared-components/user/user.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { PlaMaintenance } from '../../formwithin-document-modal';

@Component({
  selector: 'app-present-level-maintenance',
  templateUrl: './present-level-maintenance.component.html',
  styleUrls: ['./present-level-maintenance.component.css']
})
export class PresentLevelMaintenanceComponent implements OnInit {
  dialogTitle = '';
  userName: string;
  userNamePLAA: string;
  getPlaFormData: PlaMaintenance[] = [];
  getSelectedPlaValues: PlaMaintenance[] = [];
  dataField = new PlaMaintenance();
  yearId: number;
  categoryDescription: string;
  errorList: ErrorList[] = [];
  studentXMLDataId: number;
  constructor(private matDialogRef: MatDialogRef<PresentLevelMaintenanceComponent>,
    private formWithinDocumentService: FormWithinDocumentsService,
    private userService: UserService,
    private yearService: YearService) { }

  ngOnInit(): void {
    this.userName = this.userService.currentUser.UserName;
    this.userNamePLAA = this.userService.currentUser.FirstName.substring(0,1) + '. ' + this.userService.currentUser.LastName;
    this.yearId = this.yearService.defaultYear.Id;
  }

  GetChildData(data) {
    this.dataField.CategoryNote = data;
  }
  closeClick() {
    this.checkOutForm();
    this.matDialogRef.close();
  }

  checkOutForm() {
    this.formWithinDocumentService.checkOutForm(this.studentXMLDataId, this.formWithinDocumentService.spedStudentCollectionTemplate.CheckOutByUserId, false).subscribe(() => {
    });
  }

  saveClick() {
    if (this.validationCheck().length == 0) {
      this.formWithinDocumentService.plaMiantenanceData.CategoryDescription = this.dataField.CategoryDescription;
      this.formWithinDocumentService.plaMiantenanceData.CategoryNote = this.dataField.CategoryNote;
      this.formWithinDocumentService.plaMiantenanceData.UserName = this.userNamePLAA;
      this.formWithinDocumentService.savePlaData(this.yearId).subscribe(() => {
        this.closeClick();
      });
    }
  }

  validationCheck(): ErrorList[] {
    this.errorList = [];
    if (this.dataField.CategoryNote == '' || this.dataField.CategoryNote == null) {
      this.errorList.push({
        fieldName: 'Note',
        fieldRef: null,
        errorMsg: ' Note is required'
      });
    }
    return this.errorList;
  }
}
